// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingSpinner_wrapper__1A2zE","loading":"LoadingSpinner_loading__3UIDy","rings":"LoadingSpinner_rings__1Y7DY"};